import { render } from "./MediaFilterSecondary.vue?vue&type=template&id=07486d2a&scoped=true"
import script from "./MediaFilterSecondary.vue?vue&type=script&lang=js"
export * from "./MediaFilterSecondary.vue?vue&type=script&lang=js"

import "./MediaFilterSecondary.vue?vue&type=style&index=0&id=07486d2a&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07486d2a"]])

export default __exports__